var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',_vm._g(_vm._b({attrs:{"type":"link"}},'a-button',_vm.$attrs,false),_vm.$listeners),[_c('img',{staticStyle:{"width":"19px","margin-right":"4px"},attrs:{"src":!_vm.visible ? require('@/assets/report/report/ico_tab_open.png') : require('@/assets/report/report/ico_tab_close.png')}}),_vm._v(" "+_vm._s(_vm.visible ? '隐藏' : '显示')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }